import Helper from './Helper';

class SidebarScrollsWhenFooterInView {
  constructor(config = {}) {
    const {
      sidebar,
      footer,
      header,
      breakPointLg,
      breakPointMd,
      breakPointSm
    } = config;
    this.breakPointLg = breakPointLg;
    this.breakPointMd = breakPointMd;
    this.breakPointSm = breakPointSm;
    this.footer = document.querySelector(footer);
    this.sidebar= document.querySelector(sidebar);
    this.header = document.querySelector(header);

    this.footerHeight = 0;
    this.vw = 0;
    this.topOfSidebar = 180;
    this.topOfSidebarMd = 75;
    this.topOfSidebarSm = 50;

    if(sidebar && footer) {
      this.bindEvents();
    }
  }

  bindEvents(){
    this.vw = window.innerWidth;
    this.footerHeight = this.footer.offsetHeight;
    this.changeSidebar(this.sidebar, this.checkFooterIsInViewport(this.footer), this.footer);

    window.addEventListener('resize', () => {
      this.vw = window.innerWidth;
      this.footerHeight = this.footer.offsetHeight;
      this.changeSidebar(this.sidebar, this.checkFooterIsInViewport(this.footer), this.footer);
    });

    window.addEventListener("scroll", (e) =>{
      this.changeSidebar(this.sidebar, this.checkFooterIsInViewport(this.footer), this.footer);
    });
  }

  checkFooterIsInViewport(footer) {
    const bounding = footer.getBoundingClientRect();
    return (
       (window.innerHeight || document.documentElement.clientHeight) - bounding.top
    );
  }

  changeSidebar(sidebar, topOfFooter, footer) {
    if(this.vw >= this.breakPointLg) {
        const footerTop = footer.getBoundingClientRect().top;
        const sidebarHeight = sidebar.offsetHeight + 20;

        let spaceBetweenFooterHeader = (window.innerHeight || document.documentElement.clientHeight) - (this.topOfSidebar + topOfFooter);
        if( spaceBetweenFooterHeader <= sidebarHeight) {
          sidebar.style.top = `${(window.innerHeight || document.documentElement.clientHeight) - sidebarHeight - ((window.innerHeight || document.documentElement.clientHeight) - footerTop)}px`;
        } else {
          sidebar.style.top = `${this.topOfSidebar}px`;
        }
    } else if (this.vw >= this.breakPointMd && this.vw < this.breakPointLg){
      sidebar.style.top = `${this.topOfSidebarMd}px`;
    } else {
      sidebar.style.top = `${this.topOfSidebarSm}px`;
    }
  }
}

export default SidebarScrollsWhenFooterInView;
